// *******~ Import ~******** //
//? React
import { useState } from "react";
//? Assets
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
//? Components

//? CSS
import "./experiences.scss";
//? Images

//? JSON File

//? Icons
// import { MdWorkHistory } from "react-icons/md";
import { IoMdArrowDropright } from "react-icons/io";
// *******~ Import ~******** //

const Experiences = () => {
  const [key, setKey] = useState("exp2");
  const ExpLists = [
    {
      Role: "Apprentice",
      OrgName: "TIDC India Ltd.",
      Duration: "- June 2019 to June 2020",
      // Url: {
      //   Path: "https://fusioninnovative.com/",
      //   Name: "- www.fusioninnovative.com",
      // },
      Responsibilitys: [
        "Oversaw the assembly line quality check & maintenance.",
        "Performed a variety of foundry tasks on a regular basis.",
      ],
    },
    {
      Role: "Supervisor",
      OrgName: "Esgee Die Casting",
      Duration: "- Dec 2021 to Mar 2024",
      // Url: {
      //   Path: "https://fusioninnovative.com/",
      //   Name: "- www.fusioninnovative.com",
      // },
      Responsibilitys: [
        "Responsible for end-to-end production process.",
        "Supervise the entire production line & troubleshooting.",
        "Maintain co-ordination with workers and management team.",
      ],
    },
    {
      Role: "ERP Developer",
      OrgName: "Digital Wordings., Chennai",
      Duration: "March 2024 to Present",
      Url: {
        Path: "https://www.digitalwordings.com/",
        Name: "- www.digitalwordings.com",
      },
      Responsibilitys: [
        "Standards and providing seamless user interaction.",
        "CRM, Desk, and Manufacturing Modules: Hands-on experience in customizing and enhancing these modules within the Frappe framework to meet specific business needs.",
        "Travel Bus Booking Site Development: Developed a comprehensive site from scratch, enabling streamlined user booking and management functionalities.",
        "Manufacturing Site Application Development: Built an application from scratch, designed to optimize production workflows and operations.",
        "Timeline Activity Customization: Implemented advanced tracking and usability features by customizing timeline activities.",
        "Standards and providing seamless user interaction.",
      ],
    },
  ];
  return (
    <>
      <span id="experiences"></span>
      <section className="experiences-section">
        <Container>
          <Row>
            <Col xxl={12}>
              <div className="heading">
                <h2 data-aos="fade-up">Professional Experience</h2>
                <p data-aos="fade-up">
                Experienced ERP Developer proficient in building responsive and user-friendly ERP solutions, with a focus on

                <br/>
                customizing and extending cross-module functionality using the Frappe Framework.
                  {/* Experienced Mobile App Developer proficient in building
                  responsive and
                  <br /> visually engaging cross-platform mobile applications. */}
                </p>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xxl={8} md={10} lg={10}>
              <div className="experience-tab-div">
                <Tabs
                  id="experience-tab"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                >
                  {ExpLists.map((explist, index) => (
                    <Tab
                      key={`exp${index + 1}`}
                      eventKey={`exp${index + 1}`}
                      title={`${index + 1}`}
                    >
                      <div className="experience-content" data-aos="fade-up">
                        <div className="header-div">
                          <div className="title-div">
                            <h3>{explist.Role}</h3>
                            <p>{explist.Duration}</p>
                          </div>
                          <div className="org-name">
                            <div className="org">
                              <h3>{explist.OrgName}</h3>
                              {explist.OrgSubName && (
                                <span>{explist.OrgSubName}</span>
                              )}
                            </div>

                            { explist.Url && (
                            <a
                              className="stack"
                              href={explist.Url.Path}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {explist.Url.Name}
                            </a>)

                            }
                          </div>
                        </div>
                        <div className="roles-respons">
                          <h3>Roles and Responsibilities:</h3>

                          <ul>
                            {explist.Responsibilitys.map(
                              (Responsibility, index) => (
                                <>
                                  <li key={index}>
                                    <IoMdArrowDropright />
                                    <p>{Responsibility}</p>
                                  </li>
                                </>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default Experiences;
